/**
 * The aspect ratio constant which indicates that the width (of whatever the
 * aspect ratio constant is used for) is smaller than the height.
 *
 * @type {Symbol}
 */
export const ASPECT_RATIO_NARROW = Symbol('ASPECT_RATIO_NARROW');
/**
 * The aspect ratio constant which indicates that the width (of whatever the
 * aspect ratio constant is used for) is larger than the height.
 *
 * @type {Symbol}
 */
export const ASPECT_RATIO_WIDE = Symbol('ASPECT_RATIO_WIDE');
/**
 * Smallest supported mobile width.
 */
export const SMALL_MOBILE_WIDTH = '320';
/**
 * The width for desktop that we start hiding elements from the UI (video quality label, filmstrip, etc).
 * This should match the value for $verySmallScreen in _variables.scss.
 *
 * @type {number}
 */
export const SMALL_DESKTOP_WIDTH = 500;
/**
 * videoSpaceWidth 低于该值时视为窄屏：底栏走 narrowMainToolbarButtons，overflow 用抽屉。
 * 须与 filmstrip DISPLAY_DRAWER_THRESHOLD 保持一致。
 *
 * @type {number}
 */
export const NARROW_LAYOUT_THRESHOLD = 512;
